import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import WarehouseIcon from "../../Icons/WarehouseIcon";
const WareHouseListComponent = loadable(
  () => import("../../components/Warehouse/WareHouseList")
);

const WareHouseList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <WarehouseIcon/>
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Warehouse</span>
      </div>
      <WareHouseListComponent />
    </>
  );
};

export default WareHouseList;
